import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

import HeaderText from '../../components/communal/HeaderText';
import InteractionTimeout from '../../components/communal/InteractionTimeout';
import SetTitle from '../../components/communal/SetTitle';
import DestinationSwitch from '../../utilities/generic/DestinationSwitch';

import { generateId, formatDate } from '../../utilities/generic/Common.js'

class GroupLeaving extends Component {
  constructor(props) {
    super(props);

    this.handleBoolean = this.handleBoolean.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    skip: null,

    groupPeople: [],
    checkedOutPeople: [],

    validDetails: false,
    errors: "",
    error: "",
  }

  handleBoolean(event) {
    const name = event.target.name;
    const bool = event.target.value === "true"

    this.setState({[name]: bool});
  }

  handleCheckbox(event) {
    let person_id = parseInt(event.target.name);
    let checked = event.target.checked;

    if (checked) {
      this.setState(prevState => ({
        checkedOutPeople: [...prevState.checkedOutPeople, person_id]
      }));
    } else {
      this.setState(prevState => ({
        checkedOutPeople: prevState.checkedOutPeople.filter(id => id !== person_id)
      }));
    }

  }

  handleSubmit(event) {
    const leavingPeople = this.state.groupPeople.filter(person => this.state.checkedOutPeople.includes(person.id))
    if (leavingPeople.length === 0) {
      // No people means they removed all the rows. They probably didn't mean to click "Yes".
      // Let them through to the next page without rendering form errors.
      this.setState({validDetails: true})
    }

    const profile_id = this.props.location.state.profile.id
    const type_of_person = this.props.location.state.profile.type_of_person
    const leaving_app_id = this.props.location.state.leaving_app_id

    leavingPeople.forEach((person, index) => {
      const group_leaving = {
        first_name: person.first_name,
        last_name: person.last_name,
        type_of_person: type_of_person,
        profile_id: profile_id,
        app_id: generateId(),
        group_leaving_id: leaving_app_id,
        check_out_time: formatDate(new Date()),
        version: process.env.REACT_APP_COMMIT_HASH
      }

      const group_leavings = JSON.parse(localStorage.getItem("group_leavings")) || []
      group_leavings.push(group_leaving)

      localStorage.setItem("group_leavings", JSON.stringify(group_leavings))
    })

    // Remove leaving people from checked_in_groups
    const groups = JSON.parse(localStorage.getItem("checked_in_groups"))
    const group_id = this.props.location.state.person.group_id

    groups[group_id] = groups[group_id].filter(person_id => !this.state.checkedOutPeople.includes(person_id) )

    localStorage.setItem("checked_in_groups", JSON.stringify(groups))
    this.setState({validDetails: true})

    event.preventDefault();
  }

  renderGroupCheck() {
    if (this.state.skip === null) {
      return (
        <div className="content">
          <div className="widget form">
            <div className="message">
              Are you leaving with people?
            </div>

            <button className="widget button margin-right" name="skip" value="false" onClick={this.handleBoolean}>Yes</button>
            <button className="widget button" name="skip" value="true" onClick={this.handleBoolean}>No</button>
          </div>
        </div>
      )
    }
  }

  renderGroupLeavingForm(submit_button_value) {
    const { groupPeople, checkedOutPeople, skip } = this.state;

    if (skip === false) {
      return (
        <div className="content">
          <div className="widget form">
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <div className="message">
                Please tick the people you are leaving with
              </div>

              <div className="grid-container">
                <div className="grid-head">Name</div>
                <div className="grid-head">Checking out?</div>

                {groupPeople.map((person, index) => (
                  <React.Fragment key={index}>
                    <div className="grid-cell">
                      {person.first_name} {person.last_name}
                    </div>

                    <input type="checkbox" id={person.id} name={person.id} checked={checkedOutPeople.includes(person.id)} onChange={this.handleCheckbox} />
                  </React.Fragment>
                ))}
              </div>

              <input type="submit" value={checkedOutPeople.length === 0 ? "Skip" : submit_button_value} />
            </form>
          </div>
        </div>
      )
    }
  }

  render() {
    const cookies = new Cookies()
    const token = cookies.get('device_token')

    if (token === undefined) {
      return <Redirect to="/setup/user"/>
    }

    if (this.props.location.state === undefined) {
      return <Redirect to="/404" />
    }

    const profile = this.props.location.state.profile
    const person = this.props.location.state.person
    const leaving_app_id = this.props.location.state.leaving_app_id

    const destinationSwitch = new DestinationSwitch({ current_page: "group-leavings", profile: profile, person: person, direction: "leaving", leaving_app_id: leaving_app_id, personal: false });

    if (this.state.validDetails || this.state.skip) {
      return destinationSwitch.redirect()
    }

    const submit_button_value = destinationSwitch.buttonName()

    return (
      <div className="main-page group-leavings-page back-button">
        <InteractionTimeout seconds={60} />

        <SetTitle title={"Group Leaving"} />
        <HeaderText />

        {this.renderGroupCheck()}
        {this.renderGroupLeavingForm(submit_button_value)}

        <div></div>
      </div>
    );
  }

  componentDidMount() {
    const group = this.props.location.state.group
    const currentPerson = this.props.location.state.person

    const allPeople = JSON.parse(localStorage.people) || []
    const groupPeople = allPeople.filter(person => group.includes(person.id) && person.id !== currentPerson.id)

    this.setState({ groupPeople: groupPeople })
  }
}

export default GroupLeaving;
